import { Skeleton, TTableRow } from '@treezor/design-system';
import { ReactNode } from 'react';

export interface IRowSkeletonProps<T> {
  headers: (keyof T)[];
  length?: number;
}

export function RowSkeleton<T extends Record<string, ReactNode>>({
  headers,
  length = 10,
}: IRowSkeletonProps<T>): TTableRow<T>[] {
  return [...Array(length)].map((_) => {
    return headers.reduce<T>((prev, current) => {
      if (current === 'actions') {
        return {
          ...prev,
          [current]: <></>,
        };
      } else {
        return {
          ...prev,
          [current]: <Skeleton className="h-5" margin="0" />,
        };
      }
    }, null);
  });
}
